import { render, staticRenderFns } from "./EditFeeType.vue?vue&type=template&id=2b485411&scoped=true"
import script from "./EditFeeType.vue?vue&type=script&lang=js"
export * from "./EditFeeType.vue?vue&type=script&lang=js"
import style0 from "./EditFeeType.vue?vue&type=style&index=0&id=2b485411&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b485411",
  null
  
)

export default component.exports